<template>
    <template v-if="currentIdentityIsClient || !loggedIn">
        <VJoyButton
            :data-testid="dataTestid"
            :icon="checked ? 'heart-fill' : 'heart'"
            variant="secondary"
            size="xxsmall"
            circle
            class="favorite-button"
            :title="$t('wishlist.item.title', [firstName])"
            @click.prevent="currentIdentityIsClient ? openFavoriteModal() : redirectToClientSignup()"
        />
    </template>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {useAuth, useRoute, useNuxtApp} from '#imports';
    import {safelyNavigateTo} from '@malt/utils';
    import {VJoyButton} from '@maltjoy/core-vue';
    import {eventBus} from '~/config/events';

    const props = defineProps<{
        profileId: string;
        firstName: string;
        lastName: string;
        photoAbsoluteUrl: string;
        checked: boolean;
        dataTestid: string;
    }>();

    const nuxtApp = useNuxtApp();
    const route = useRoute();
    const authStore = useAuth();

    const {currentIdentityIsClient, loggedIn} = storeToRefs(authStore);
    const {emit} = eventBus;

    const profileIdParam = route.query.id as string;
    const fullName = route.query.fullName as string;
    const photoAbsoluteUrlParam = route.query.photoAbsoluteUrl as string;

    nuxtApp.hook('page:finish', () => {
        if (route.query.favoriteModal === 'true') {
            openFavoriteModal();
        }
    });

    function openFavoriteModal() {
        emit('profile-card:favorite:add-profile:open-dialog', {
            id: profileIdParam || props.profileId,
            fullName: fullName || `${props.firstName} ${props.lastName}`,
            photoAbsoluteUrl: photoAbsoluteUrlParam || props.photoAbsoluteUrl,
        });
    }

    async function redirectToClientSignup() {
        await safelyNavigateTo(
            {
                path: `/signup-client/email?redirect=${encodeURIComponent(
                    route.fullPath +
                        '&favoriteModal=true' +
                        `&id=${props.profileId}` +
                        `&fullName=${props.firstName} ${props.lastName}` +
                        `&photoAbsoluteUrl=${props.photoAbsoluteUrl}`,
                )}`,
            },
            {externalToThisApp: true},
        );
    }
</script>

<style scoped lang="scss">
    .favorite-button {
        background-color: var(--joy-color-neutral-0);
    }
</style>
